import { Search } from 'lucide-react';

import DepartmentDropdown from './DepartmentDropdown';
import ProductiveToggle from './ProductiveToggle';

type UsageFiltersProps = {
  search: string;
  department: string;
  productiveOnly: boolean;

  onSearchChange: (
    value: string,
  ) => void;

  onDepartmentChange: (
    value: string,
  ) => void;

  onProductiveToggle: (
    value: boolean,
  ) => void;

  onClearFilters: () => void;
};

const departments = [
  'All Departments',
  'EAM',
  'Claims Ops',
  'HR',
  'Finance Ops',
  'Provider Ops',
  'Solution Team',
];

const UsageFilters = ({
  search,
  department,
  productiveOnly,
  onSearchChange,
  onDepartmentChange,
  onProductiveToggle,
  onClearFilters,
}: UsageFiltersProps) => {
  return (
    <div
      className="
        flex
        flex-wrap
        items-center
        gap-2
      "
    >
      {/* Search */}

      <div className="relative">
        <Search
          size={14}
          className="
            absolute
            left-3
            top-1/2
            -translate-y-1/2
            text-[#667085]
          "
        />

        <input
          type="text"
          value={search}
          placeholder="Search Employee"
          onChange={(e) =>
            onSearchChange(
              e.target.value,
            )
          }
          className="
            h-[36px]
            w-[220px]
            rounded-[8px]
            border
            border-[#D0D5DD]
            bg-white
            pl-9
            pr-3
            text-[12px]
            text-[#111827]
            outline-none
            focus:border-[#002B5B]
          "
        />
      </div>

      {/* Department */}

      <DepartmentDropdown
        value={department}
        options={departments}
        onChange={
          onDepartmentChange
        }
      />

      {/* Clear Filters */}

      <button
        onClick={onClearFilters}
        className="
          h-[36px]
          rounded-[8px]
          border
          border-[#D0D5DD]
          bg-white
          px-4
          text-[12px]
          font-medium
          text-[#344054]
          transition-colors
          hover:bg-[#F9FAFB]
        "
      >
        Clear Filters
      </button>

      {/* Productive Toggle */}

      <ProductiveToggle
        enabled={productiveOnly}
        onChange={
          onProductiveToggle
        }
      />
    </div>
  );
};

export default UsageFilters;